export {
  useHighlightSelectionDescription,
  type HighlightSelectionDescriptionProps
} from '../../../src/grid/useHighlightSelectionDescription';
